// extracted by mini-css-extract-plugin
module.exports = {"container":"loginPage_container__1RZjQ"};